import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {
  PickingSetting,
  PickingTypeOrdering,
  PickingSettingWeigth
} from '../interfaces';
import { environment } from './../../../environments/environment';
import { of, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TempStorageService } from './temp-storage.service';

import moment from 'moment';
import { SUPERMERCADOS_CODE } from '../configs/company.config';

@Injectable({
  providedIn: 'root'
})
export class PickingSettingService extends TempStorageService {

  /**
   * Creates an instance of picking setting service.
   * @param apiService ApiService
   */
  constructor(public apiService: ApiService) {
    super();
  }
  /**
   * Gets commons setting
   * @param [params] any
   * @returns Observable<PickingSetting>
   */
  get(params: any): Observable<PickingSetting> {
    return this.apiService.get(`${environment.apiPicking}/setting`, params);
  }
  /**
   * Gets setting
   * @returns Observable<PickingSetting>
   */
  getSetting(): Observable<PickingSetting> {
    const settingEntityStorage = this.getStorage('SETTING_ENTITY');
    return settingEntityStorage
      ? of(settingEntityStorage)
      : this.apiService
        .get(`${environment.apiPicking}/setting`)
        .pipe(tap(res => this.setStorage('SETTING_ENTITY', res)));
  }
  /**
   * Gets setting storage
   * @returns any
   */
  getSettingStorage() {
    return this.getStorage('SETTING_ENTITY');
  }
  /**
   * Puts picking setting service
   * @param params PickingSetting
   * @returns Observable<any>
   */
  put(params: PickingSetting): Observable<any> {
    return this.apiService.put(`${environment.apiPicking}/setting`, params);
  }
  /**
   * Gets weigth
   * @param params PickingSetting
   * @returns Observable<PickingSettingWeigth>
   */
  getWeigth(params: PickingSettingWeigth): Observable<PickingSettingWeigth[]> {
    return this.apiService.get(
      `${environment.apiPicking}/setting/weigth`,
      params
    );
  }
  /**
   * Puts weigth
   * @param params PickingSettingWeigth
   * @returns Observable<any>
   */
  putWeigth(params: PickingSettingWeigth[]): Observable<any> {
    return this.apiService.put(
      `${environment.apiPicking}/setting/weigth`,
      params
    );
  }
  
  /**
   * Data fot type Ordering
   * @return company ordering data 
   */
  typeOrderingLista:PickingTypeOrdering[] = [
    { description: 'Predeterminado', type: 'dateCreated', companyCode: '' },
    { description: 'Divisiones', type: 'product.division', companyCode: '' },
    { description: 'Area', type: 'product.area', companyCode: '' },
    { description: 'Predeterminado', type: 'dateCreated', companyCode: SUPERMERCADOS_CODE },
    { description: 'Area', type: 'product.area', companyCode: SUPERMERCADOS_CODE },
    { description: 'Seccion', type: 'product.section', companyCode: SUPERMERCADOS_CODE },
    { description: 'Linea', type: 'product.line', companyCode: SUPERMERCADOS_CODE },
    { description: 'Familia', type: 'product.family', companyCode: SUPERMERCADOS_CODE }
  ]
  /**
   * Gets type ordering
   * @returns Observable<PickingTypeOrdering>
   */
  getTypeOrdering(compnayCode:string): Observable<PickingTypeOrdering[]> {
    return of(this.typeOrderingLista.filter(x => x.companyCode == compnayCode));
  }
  /**
   * Posts turn
   * @param params any
   * @returns turn Observable<any>
   */
  postTurn(params: any): Observable<any> {
    return this.apiService.post(`${environment.apiPicking}/setting/turn`, params);
  }

  /**
   * Gets turn
   * @param params any
   * @returns turn Observable<any>
   */
  getTurn(params: any): Observable<any> {
    return this.apiService.get(`${environment.apiPicking}/setting/turn`, params);
  }
  /**
   * Deletes turn
   * @param turnId number
   * @returns turn Observable<any>
   */
  deleteTurn(turnId: number): Observable<any> {
    return this.apiService.delete(`${environment.apiPicking}/setting/turn/${turnId}`);
  }
  /**
   * Gets time highest number
   * @param trunList any[]
   */
  getTimeHighestNumber(turnList: any[]) {
    let turnHighest: any;
    for (const turn of turnList) {
      const currentDate = moment(turn.endTime, 'hh:mm').format();
      turnHighest = moment(turn.endTime, 'hh:mm').format();
      if (currentDate > turnHighest) {
        turnHighest = currentDate;
      }
    }
    return turnHighest;
  }

  getHolidays(startOfMonth: string, endOfMonth: string) {
    return this.apiService.get(`${environment.apiIntegRoute}/routes/holiday-calendar`, {from: startOfMonth, to: endOfMonth});

  }
}
